export default __webpack_public_path__ + "static/media/175.6053c391.svg";